<template>
    <div class="law-verify-page">
        <div class="header">
            <div class="avatar">
                <img v-if="personal_avatar" :src="personal_avatar" />
                <img v-else src="../../../../assets/img/law/headdefault.png" />
            </div>
            <div class="info">
                <div class="title">
                    欢迎登录律临！完成认证即可领取律临免费体验会员
                </div>
                <div class="subTitle">
                    体验尊享会员15日，使用超10项律师专属权益
                </div>
            </div>
            <veui-button
                class="button" :style="{background: authenticationStatus === 2 ? '#93b5f9' : '#0055ff'}"
                ui="primary" @click="goVerify"
            >
                {{
                    authenticationStatus === 2
                        ? "认证审核中"
                        : authenticationStatus === 3
                        ? "认证失败，重新认证"
                        : "立即认证"
                }}
            </veui-button>
        </div>
        <free-vip-content />
        <veui-button class="footer-button" ui="primary" @click="goVerify">
            {{
                authenticationStatus === 2
                    ? "认证审核中"
                    : authenticationStatus === 3
                    ? "认证失败，重新认证"
                    : "立即认证"
            }}
        </veui-button>
    </div>
</template>
<script>
/**
 * @file index.vue
 * @desc 律师认证引导页
 * @author <lice02@baidu.com>
 */

import { mapState } from 'vuex';
import { Button } from 'veui';
import FreeVipContent from '@/components/vip/free-vip-content';
import get from 'lodash/get';

export default {
    components: {
        'veui-button': Button,
        'free-vip-content': FreeVipContent
    },
    data() {
        return {
            bestRightsList: [],
            goodRightsList: []
        };
    },
    computed: {
        ...mapState({
            personal_avatar: state => state.lawStore.userInfoNew?.lawyer_info?.personal_avatar || '',
            authenticationStatus: (state) =>
                state.lawStore.authenticationStatus
        })
    },
    watch: {
        authenticationStatus(val) {
            this.$wywLog.addKey({
                authenticationStatus: val
            });
            this.$wywLog.send({
                serverId: 16844,
                area: 'hyrzyd',
                action: 'pv'
            });
        }
    },
    methods: {
        // 去完成认证
        goVerify() {
            const isEdit = this.authenticationStatus === 1;
            this.$wywLog.send({
                serverId: 16844,
                area: 'hyrzyd-btn',
                action: 'click'
            });
            this.$router.push({
                name: 'material',
                query: {
                    from: 'lawverifyguide',
                    ...(isEdit && {
                        isEdit: 'edit',
                        editAnchor: 'authentice_title'
                    })
                }
            });
        }
    }
};
</script>
<style lang="stylus" scoped>
.law-verify-page {
    position: relative;
    background: #fff;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, 0.35);
    border-radius: 8px;
    padding: 30px 30px 40px 30px;
    .header {
        width: 100%;
        height: 148px;
        background-image: linear-gradient(136deg, #EBF6FF 0.04%, #EBF2FF 100%);
        padding: 30px 30px 30px 24px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        .avatar {
            flex: 0 0 auto;
            width: 98px;
            height: 98px;
            border-radius: 50%;
            border: 4px solid rgba(255, 255, 255, 0.6);
            overflow: hidden;
            img {
                background: linear-gradient(180deg, #A6AFBE 0%, #CCD0D7 100%);
                border: 0.5px solid rgba(0, 0, 0, 0.10);;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .info {
            flex: 1 0 auto;
            margin-left: 16px;
            .title {
                font-family: PingFangSC-Medium;
                font-size: 24px;
                color: #1e1f24;
                line-height: 1;
                font-weight: 500;
                position relative;
                top: 2px;
            }
            .subTitle {
                margin-top: 18px;
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #848691;
                line-height: 1;
                font-weight: 400;
            }
        }
        .button {
            flex: 0 0 auto;
            min-width: 176px;
            height: 40px;
            padding: 0 16px;
            background: #0055ff;
            border-radius: 5px;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #fff;
            line-height: 1;
            font-weight: 500;
            &:hover {
                opacity: 0.8;
            }
        }
    }
    .footer-button {
        margin-left: 50%;
        transform: translateX(-50%);
        width: 326px;
        height: 48px;
        background: #0055ff;
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #fff;
        line-height: 1;
        font-weight: 500;
        &:hover {
            background: #0055ff;
            opacity: 0.8;
        }
    }
}
</style>
